/* eslint-disable @typescript-eslint/naming-convention */

export const breakpoints = {
    sm: '30em',
    md: '45em',
    lg: '63em',
    xl: '80em',
    '2xl': '96em',
}
